<div class="w-full flex justify-between items-center cursor-pointer pointer-events-auto">
  <div class="py-1">
    @if (title) {
      <h3 class="text-sm font-bold text-typography-primary">{{ title }}</h3>
    }

    <div class="mt-1">
      @if (message) {
        <p class="text-sm text-typography-muted">{{ message }}</p>
      } @else {
        <p class="text-sm text-typography-muted">{{ now() | date: "EEEE, MMMM dd, y 'at' h:mm a" }}</p>
      }
    </div>
  </div>

  @if (options.payload?.undo) {
    <div class="self-start">
      <button class="rounded-lg bg-primary text-sm text-white px-2 leading-6" (click)="action($event)">
        {{ 'report.toast.undo' | transloco }}
      </button>
    </div>
  }
</div>
